<template>
  <div class="container">
    <div>
      <div v-for="item in manifestList" v-bind:key="item">
        <div class="manifestItem">
          <div class="itemBox">
            <div class="data">
              <div class="label">specimen collected</div>{{ formatDate(item.biopsy_time) }}
            </div>
            <div class="data">
              <div class="label">Accession Number</div>{{ item.accession_number ?? 'None' }}
            </div>
            <div class="data">
              <div class="label">Physician</div>{{ item.performing_physician ?? 'N/A' }}
            </div>
          </div>
          <img v-bind:src="item.thumbnail.url" class="thumbImage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, onMounted, watch, ref, defineEmits } from 'vue'
import { useStore } from 'vuex'
import { parseISO, format } from 'date-fns'
import { getPathology } from './getPathology.js'
import loadThumbnails from './loadThumbnails.js'

const store = useStore()

const emit = defineEmits(['onManifestCountChange'])

const patientId = computed(() => store.getters.session?.patient?.id || '')

const manifestList = ref([])

const formatDate = (dateString) => {
  const date = parseISO(dateString)
  return format(date, 'MMMM d, yyyy')
}

const loadSamples = async (id) => {
  if (!id) return
  const results = await getPathology(id)
  manifestList.value = results || []

  emit('onManifestCountChange', manifestList.value.length)
}

watch(patientId, () => {
  loadSamples(patientId.value)
})

watch(manifestList, async () => {
  manifestList.value = await loadThumbnails(manifestList.value)
})

onMounted(async () => {
  loadSamples(patientId.value)
})
</script>

<style lang="scss" scoped>
.thumbImage {
  max-width: 100px;
  max-height: 90px;
  margin: 20px;
  border-radius: 10px;
}

.label {
  color: var(--Grey500);
  font-size: 80%;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.data {
  color: var(--Black);
  font-size: 80%;
  margin-bottom: 15px;
}


.item {
  margin: 10px;
  cursor: pointer;
  padding: 10px;
}

.itemBox {
  margin: 20px;
}

.manifestItem {
  display: flex;
  justify-content: space-between;
  text-align: left;
  border-bottom: 1px dotted var(--Grey400);
  transition: all linear 200ms;
}

.manifestItem:hover img {
  box-shadow: 0px 0px 5px 3px var(--Grey500);
}

.item .selected {
  background-color: var(--PrimaryLight);
}
</style>
